/**
 * 查询条件封装
 * 入参：programId 作业编号
 * isAutoSearch 是否自动查询
 * isProgram 是否作业调用
 * onSearch 查询事件响应
 * isAutoHeight 是否自动布局
 * isDiy 是否自定义作业
 */
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit, Inject,NgModule, ViewChild  } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
// import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { isString, isDate, isArray } from 'util';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
import { DatePipe } from '@angular/common';
import { DwRouteInfoService, DwRoutingMessageService, APP_DATE_FORMAT, APP_DATE_TIME_FORMAT } from '@webdpt/framework';
import { DwModalService } from 'ng-quicksilver';
import { saveCondComponent } from './modal/save-comcond';
import { editCondComponent } from './modal/edit-comcond';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as moment from 'moment';
import { FxDapHttpClient } from '../fx-http-client';
import { calDate } from 'app/implementation/shared/services/common-method';
import * as _ from 'lodash';
import { SetOrderByComponent } from './modal/set-orderby';
import { FormArray } from '@angular/forms';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { textModalComponent } from './modal/text-modal';
import { IDwRouteInfo } from '../../../../../projects/webdpt/framework/components/dw-tab-routing/interface/route-info.interface';
import { getMenuName } from 'app/implementation/shared/services/common-method';
import { FxToolBarComponent } from '../components/fx-tool-bar/fx-tool-bar.component';

@Component({
  selector: 'app-search-more',
  templateUrl: './search-more.component.html',
  styleUrls: ['./search-more.component.less'],
  animations: [
    trigger('childAnimation', [
      state('block', style({ opacity: 1, transform: 'translateY(0px)' })),
      state('none', style({ transform: 'translateY(10px)', opacity: 0 })),
      transition('none <=> block', animate(500)),

      // transition(':enter', [
      //   style({ opacity: 0, transform: 'translateX(10px)' }),
      //   animate('5s', style({ opacity: 1, transform: 'translateX(0)'})),
      // ]),
      // transition(':leave', [
      //   style({ opacity: 0, transform: 'translateX(0)'}),
      //   animate('5s', style({ opacity: 0, transform: 'translateX(10px)' }))
      // ])
    ]),
  ]
})
export class SearchMoreComponent implements OnInit, AfterViewInit {
  tabs: IDwRouteInfo[] = [];
  public _programId: string;
  @Input() set programId(programId: string) {
    this._programId = (programId && programId.trim());
  }
  @Input() isAutoSearch = true;

  get programId(): string {
    return this._programId;
  }
  @Input() isProgram = true;
  @Input() isAutoHeight = true;
  @Input() btnData: Array<any> = [];
  @Input() isDiy = false;

  @Output() onSearch = new EventEmitter<boolean>();
  @Output() openModal = new EventEmitter<boolean>();
  @Output() onReady = new EventEmitter<any>();
  @Output() OptionList = new EventEmitter<boolean>();
  @Output() onRefreshBtns = new EventEmitter<any>(); // 通过事件传播刷新按钮
  @ViewChild('ftbComp') ftbComp: FxToolBarComponent;

  public fxScheduleAry = [];
  public colorName = ['color1', 'color2', 'color3', 'color4', 'color5', 'color6', 'color7', 'color8', 'color9', 'color1', 'color4', 'color8']
  public sortList=['客户编号','客户姓名','客户年龄']
  public nowOpenIndex = 0;
  public conditionList: Array<any> = []; // 常用查询条件
  public conditionList2=[]; // 常用查询条件
  // 進階查詢開合 true:關閉, false:打開
  @Input() isCollapse = true;
  public c_S004 = '0';
  public c_P119 = 'Y';
  public isShowSort= false;
  public btnListAll: Array<any> = [];
  // 查询条件  ==  begin ==
  public searchParam = {
    pageable: true,
    // pageSize: 10,
    // pageNumber: 1,
    glikesel: '',
    gcomConds: '',
    orderfields: [],
    condition: {
      joinOperator: 'AND',
      items: []
    }
  }; //查询条件结果
  public gcomCondsList = []; //常用查询条件
  public gcomCondsList2 = [{ label: '保存常用查询', value: 'save' }, { label: '编辑常用查询', value: 'edit' }]; //常用查询条件-只有保存和编辑
  public searchlableList = []; //更多查询label
  // public searchCondList = []; //更多查询条件
  public searchCondList = {
    'all': [], 'select': [], 'date': [], 'month': [], 'self': []
  };//更多查询条件 //根据字段类型不同显示不同内容
  public searchVal = []; //更多查询value
  public aa = [];
  public searchValNum = 3; //更多查询个数
  public searchValObj = { table_no: '', field_no: '', condition: 'EQUAL', value: '', lable_type: '3', more01: [], cond_type: 'all', aae005: 'VARCHAR2', openKey: '', param_list: null, aal005: '', aal008: '', aal004: '' };
  // public gcomCondsList = [
  //   { text: '常用条件1', value: '1' },
  //   { text: '常用条件2', value: '2' }
  // ];
  //查询条件字段
  //lable_type 1开窗 2下拉 3输入 4日期 5日期+时间 7年月 8日期区间
  // 查询条件  ==  end  ==
  public heightEle; //页面高度布局ele
  public initHeight; //页面布局初始高度
  public keyWords = this.translateService.instant('com-请输入关键字'); //关键字提示信息
  public orderByListInit = []; //作业注册配置排序列表
  public orderByList = []; //已选择排序列表
  public dwDateMonthFormat;
  public aca006='';
  public aca015='';
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private dwRouteInfoService: DwRouteInfoService,
    public dwMessage: DwRoutingMessageService,
    public http: FxDapHttpClient,
    private userService: FxUserInfoService,
    public fxModalService: FxModalService, // 分销自定提醒框
    public dwModalService: DwModalService,
    private datePipe: DatePipe,
    // public doc: DwDocument,
    private translateService: TranslateService,
    @Inject(APP_DATE_FORMAT) public dwDateFormat: string, // 自定义日期格式变量
    @Inject(APP_DATE_TIME_FORMAT) public dwDateTimeFormat: string, // 自定义日期格式变量
  ) {
    this.dwDateMonthFormat = dwDateFormat.substring(0, 7);
  }

  public isCollapseInit = false;
  public hasCon = false; // 记录当前页面是否有常用查询条件

  ngOnInit(): void {
    if (this.btnData && this.btnData.length) {
      this.btnListAll = JSON.parse(JSON.stringify(this.btnData));
    }
    console.log('searchMore', this)
    this.getProgramParam();
    this.pageInit(); //页面初始化
    this.dataInit(); //获取初始数据
    // this.getStorageCondition();
    // this.searchData();
    console.log(this.searchVal)

    var formEles = document.getElementsByTagName("form");
    if (formEles.length > 0)  { //页面存在grid
      var formEle = <HTMLElement>formEles.item(0);
      if (formEle.outerHTML.indexOf('height: calc(100vh - ') > -1 || formEle.outerHTML.indexOf('height:calc(100vh - ') > -1) { //页面高度计算在form上
        this.heightEle = formEle;
        this.initHeight = this.heightEle.style.height;
      }
    }
    var gridEles = document.getElementsByTagName("ag-grid-angular");
    if (gridEles.length > 0)  { //页面存在grid
      var gridEle = <HTMLElement>gridEles.item(0);
      if (gridEle.outerHTML.indexOf('height: calc(100vh - ') > -1 || gridEle.outerHTML.indexOf('height:calc(100vh - ') > -1) { //页面高度计算在grid上
        this.heightEle = gridEle;
        this.initHeight = this.heightEle.style.height;
      }
    }

    var autoHeightEles = document.getElementById("autoHeight");
    if (autoHeightEles)  {
      this.heightEle = autoHeightEles;
      this.initHeight = this.heightEle.style.height;
    }

    setTimeout(() => {
      let count=3-(this.searchVal.length%3)
      if(count==1||count==2){
        const newobj = Object.assign({}, this.searchValObj);
        this.searchVal.push(newobj);
      }
      if(count==2){
        const newobj = Object.assign({}, this.searchValObj);
        this.searchVal.push(newobj);
      }
    }, 500);
  }

  // 获取是否自动查询列表作业参数
  async getProgramParam(): Promise<any> {
    const programParam = await this.userService.getProgramParamById$(this._programId).toPromise();
    this.c_P119 = (programParam && programParam.has('c_P119')) ? programParam.get('c_P119') : '';
    // 如果作业参数有设定则优先使用作业参数，否则使用作业代码里面的，1，如果是首页跳转的，2.如果有默认查询条件，3.详情页返回的（根据是否有缓存判断）则默认都查询
    const homeIsAutoSearchParam = sessionStorage.getItem('homeIsAutoSearchParam' + this._programId);
    const detailRetrunParam = sessionStorage.getItem(this._programId + '_searchMore');
    var isGoBack;
    this.route.queryParamMap.subscribe( // 路由变化执行
      params => {
        isGoBack = params.get('isGoBack') == 'true' ? true : false;
      }
    );
    if (homeIsAutoSearchParam === 'Y') {// 首页跳转的
      this.isAutoSearch = true;
      sessionStorage.removeItem('homeIsAutoSearchParam' + this._programId);
    } else if(detailRetrunParam && isGoBack) {// 详情页返回的
      this.isAutoSearch = true;
    } else {
      if (this.c_P119 === 'Y') {
        this.isAutoSearch = true;
      } else if (this.c_P119 === 'N') {
        this.isAutoSearch = false;
      }
    }
  }

  /**
   * name
   */
  public pageInit(): void {
    // this.c_S004 = this.userService.getSysParamById('c_S004') || '0';
    // 1.下拉，=(in)，不等于，空白，非空
    // 2.开窗，=(in)，不等于，包含，不包含，空白，非空
    // 3.1输入，字符类型不等于，包含，不包含，空白，非空,开头，结尾
    // 3.2输入，数值类型：=，>=，<=，>，<，不等于，区间，空白，非空
    // => ：=(in)，>=，<=，>，<，包含，不包含，区间, 空白，非空,开头，结尾
    // 4.日期，=，>=，<=，>，<，不等于，区间，空白，非空
    // 5.日期时间，=，>=，<=，>，<，不等于，区间，空白，非空
    // =>区间，当天，三天内，一周内，一月内
    this.searchCondList = {
      'all': [
        { label: '=', value: 'EQUAL' },
        { label: '>', value: 'GreaterThan' },
        { label: '>=', value: 'GreaterThanOrEqualTo' },
        { label: '<', value: 'LessThan' },
        { label: '<=', value: 'LessThanOrEqualTo' },
        { label: '不等于', value: 'NotEquals' },
        { label: '包含', value: 'LIKE' },
        { label: '不包含', value: 'NOT_LIKE' },
        { label: '区间', value: 'BETWEEN' },
        { label: '空白', value: 'IS_BLANK' },
        { label: '非空', value: 'NOT_BLANK' },
        { label: '开头', value: 'StartWith' },
        { label: '结尾', value: 'EndWith' }
      ],
      'select': [
        { label: '=', value: 'EQUAL' },
        { label: '不等于', value: 'NotEquals' },
        { label: '空白', value: 'IS_BLANK' },
        { label: '非空', value: 'NOT_BLANK' }
      ],
      'date': [
        { label: '=', value: 'EQUAL' },
        { label: '>', value: 'GreaterThan' },
        { label: '>=', value: 'GreaterThanOrEqualTo' },
        { label: '<', value: 'LessThan' },
        { label: '<=', value: 'LessThanOrEqualTo' },
        { label: '不等于', value: 'NotEquals' },
        { label: '空白', value: 'IS_BLANK' },
        { label: '非空', value: 'NOT_BLANK' },
        { label: '区间', value: 'BETWEEN' },
        { label: '当天', value: 'TODAY' },
        { label: '三天内', value: 'THREE' },
        { label: '一周内', value: 'WEEK' },
        { label: '一月内', value: 'MONTH' },
        { label: '当月', value: 'NOW_MONTH' },
        { label: '上月', value: 'LAST_MONTH' },
        { label: '当年', value: 'NOW_YEAR' },
        { label: '去年', value: 'LAST_YEAR' }
      ],
      'month': [
        { label: '=', value: 'EQUAL' },
        { label: '>', value: 'GreaterThan' },
        { label: '>=', value: 'GreaterThanOrEqualTo' },
        { label: '<', value: 'LessThan' },
        { label: '<=', value: 'LessThanOrEqualTo' },
        { label: '不等于', value: 'NotEquals' },
        { label: '空白', value: 'IS_BLANK' },
        { label: '非空', value: 'NOT_BLANK' },
        { label: '区间', value: 'BETWEEN' },
      ],
      'self': [
        { label: '=', value: 'EQUAL' },
        { label: '>', value: 'GreaterThan' },
        { label: '>=', value: 'GreaterThanOrEqualTo' },
        { label: '<', value: 'LessThan' },
        { label: '<=', value: 'LessThanOrEqualTo' },
        { label: '不等于', value: 'NotEquals' },
        { label: '包含', value: 'LIKE' },
        { label: '不包含', value: 'NOT_LIKE' },
        { label: '区间', value: 'BETWEEN' },
        { label: '空白', value: 'IS_BLANK' },
        { label: '非空', value: 'NOT_BLANK' },
        { label: '开头', value: 'StartWith' },
        { label: '结尾', value: 'EndWith' },

        { label: '当天', value: 'TODAY' },
        { label: '三天内', value: 'THREE' },
        { label: '一周内', value: 'WEEK' },
        { label: '一月内', value: 'MONTH' },
        { label: '当月', value: 'NOW_MONTH' },
        { label: '上月', value: 'LAST_MONTH' },
        { label: '当年', value: 'NOW_YEAR' },
        { label: '去年', value: 'LAST_YEAR' }
      ]
    };
    for (let index = 0; index < this.searchValNum; index++) {
      const newobj = Object.assign({}, this.searchValObj);
      this.searchVal[index] = newobj;
    }
  }

  /**
   * name
   */
  public dataInit(): void {
    this.getStorageCondition();
    this.userService.getSysEnumById$('4').subscribe(res => {
      this.searchCondList.all = this.getCondlabel(this.searchCondList.all, res);
      this.searchCondList.select = this.getCondlabel(this.searchCondList.select, res);
      this.searchCondList.date = this.getCondlabel(this.searchCondList.date, res);
      this.searchCondList.month = this.getCondlabel(this.searchCondList.month, res);
    });
    this.searchlableList = []; //更多查询label
    var labelParam = {
      aah001: this._programId,
      option_type: '3'
    };
    this.http.post<any>('A/IACommonService/pub_get_aah', { param: labelParam }).subscribe(result => {
      console.log('更多查询label', result);
      // 查询条件是开窗的时候备份一下原始开窗参数，方便后续开窗级联查找上级参数
      result.data.forEach(x => {
        if (x.aal004 == '1' && x.param_list) {
          x.param_list_bak = JSON.parse(JSON.stringify(x.param_list));
          x.field_no = x.value;
        }
      })
      this.searchlableList = result.data;
      this.searchlableList.push({ label: this.translateService.instant('com-请选择'), value: '' });
      // this.onAfterSearch();
      if (result.data2 && result.data2.length > 0) {
        this.keyWords =  this.translateService.instant('com-请输入')+ result.data2.map(obj => {
          return obj.label;
        }).join(',');
      }
      if (result.data3 && result.data3.length > 0) { //排序资料
        this.orderByListInit = result.data3 || [];
        this.orderByList = this.orderByListInit.filter(obj =>{ return obj.acj004 == 'Y'});
        console.log('====获取到排序数据')
      }
      this.getComCondData(false, true);
    });

    // this.getComCondData();

  }

  //获取常用查询条件
  getComCondData(isCollapse?: boolean, isReay?: boolean): void {
    if (!this.isProgram) { return; } //如果是查询条件设置作业调用
    var comCondParam = {
      aan001: this.userService.userInfo['c_user'], //用户编号
      aan002: this._programId //作业编号
    };
    this.http.post<any>('A/IACommonService/pub_get_aan', { param: comCondParam }).subscribe(result => {
      let param2 = this.getALLCondition(result.data);
      this.userService.getProgramParamById$
      this.http.post<any>('A/IACommonService/getConditionCounts', { param: param2 }).subscribe(resp => {
        if(resp.success){
          this.conditionList = result.data || [];
          console.log(this.conditionList)
          if(this.conditionList.length==0){
            this.conditionList=resp.data.acalist
          }else{
            const conditionCountsList = resp.data;
            this.conditionList.forEach(x => {
              if(x.aan001){
                x.counts = conditionCountsList[x.value];
              }
            })
            let content=[]
            for(let i in resp.data.acalist){
              let flag=true;
              for(let j in this.conditionList){
                if(resp.data.acalist[i].aan003_n1==this.conditionList[j].aan003_n1){
                  flag=false
                  this.conditionList[j].counts=resp.data.acalist[i].counts
                }
              }
              if(flag){
                content.push(resp.data.acalist[i]);
              }
            }
            this.conditionList=content.concat(this.conditionList);
          }
          this.conditionList2=[]
          this.conditionList.forEach(obj => {
            if(obj.value == "edit" || obj.value == "save"){}else{
              this.conditionList2.push(obj);
            }
          })
          if(this.conditionList2.length>0){
            var targetEle = document.getElementById('fx_program_target_'+this._programId);
              var serachTargetEle = document.getElementById('fx_search_'+this._programId);
              var toolBarEle = document.querySelector('app-'+ (this.isDiy ? 'fxaq017' : this._programId) + '-s01 .dw-f-btn');
              var gridHead = document.querySelector('app-'+(this.isDiy ? 'fxaq017' : this._programId)+ '-s01 .fx_grid_head');
              if (toolBarEle) {
                toolBarEle.setAttribute("style", "top: 40px;position: absolute;z-index: 2;");
              }
              if (gridHead) {
                gridHead.setAttribute("style", "position: relative;");
              }
              if (serachTargetEle) {
                serachTargetEle.setAttribute("style", "position: relative;width: 40%;margin-left: 60%;z-index: 1;");
              }
              if (targetEle) {
                targetEle.setAttribute("style", "height: 60px;display:flex;");
              }
              if (!this.hasCon && this.heightEle) {
                this.hasCon = true;
                this.heightEle.style.height = this.initHeight.replace(')', (' - ' + 44  + 'px)'));
                this.initHeight = this.heightEle.style.height;
              }
              if (this.isCollapse) { //关闭更多查询
                this.heightEle.style.height = this.initHeight;
              } else {
                var count = this.searchVal.length > 24 ? 33*8 +5+33 : (33 * Math.ceil(this.searchVal.length / 3)) + 6.5;
                this.heightEle.style.height = this.initHeight.replace(')', (' - ' + count  + 'px)'));
              }
          }else{
            if (!this.isCollapseInit) {
              this.isCollapseInit = true;
            }
            if (this.hasCon && this.heightEle) {
              this.hasCon = false;
              this.heightEle.style.height = this.initHeight.replace(')', (' + ' + 44  + 'px)'));
              this.initHeight = this.heightEle.style.height;
            }
              var targetEle = document.getElementById('fx_program_target_'+this._programId);
              var serachTargetEle = document.getElementById('fx_search_'+this._programId);
              var toolBarEle = document.querySelector('app-'+(this.isDiy ? 'fxaq017' : this._programId)+ '-s01 .dw-f-btn');
              var gridHead = document.querySelector('app-'+(this.isDiy ? 'fxaq017' : this._programId)+ '-s01 .fx_grid_head');
              if (toolBarEle) {
                toolBarEle.removeAttribute("style");
              }
              if (gridHead) {
                gridHead.removeAttribute("style");
              }
              if (serachTargetEle) {
                serachTargetEle.removeAttribute("style");
              }
              if (targetEle) {
                targetEle.removeAttribute("style");
              }
            }
          this.clickCollapse(false);
        }
      })

      console.log('常用查询', result);
      this.gcomCondsList = result.data;
      if (isArray(this.gcomCondsList) && this.gcomCondsList.length > 0) {
        for (let index = 0; index < this.gcomCondsList.length; index++) {
          //this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(":USER",this.userService.userInfo['c_user'])
         if(typeof this.gcomCondsList[index].aan004 === 'string'){
          this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(/:USER/g, this.userService.userInfo['c_user'])
          this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(/:TODAY/g, this.datePipe.transform(new Date(), this.dwDateFormat))
          this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(/:ORG/g, this.userService.userInfo['c_org'])
          this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(/:PER/g, this.userService.userInfo['c_per'])
          //this.gcomCondsList[index].aan004 = this.gcomCondsList[index].aan004.replace(":YESTERDAY",this.datePipe.transform(new Date(),this.dwDateFormat))
          if (this.gcomCondsList[index].aan004.indexOf('TODAY') != -1 || this.gcomCondsList[index].aan004.indexOf('THREE') != -1
            || this.gcomCondsList[index].aan004.indexOf('WEEK') != -1 || this.gcomCondsList[index].aan004.indexOf('MONTH') != -1
            || this.gcomCondsList[index].aan004.indexOf('NOW_MONTH') != -1 || this.gcomCondsList[index].aan004.indexOf('LAST_MONTH') != -1
            || this.gcomCondsList[index].aan004.indexOf('NOW_YEAR') != -1 || this.gcomCondsList[index].aan004.indexOf('LAST_YEAR') != -1) {
            this.gcomCondsList[index].aan004 = JSON.parse(this.gcomCondsList[index].aan004);
            var oneDay = 1000 * 60 * 60 * 24;
            var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
            var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
            var now_Date = new Date();
            this.gcomCondsList[index].aan004.moresel.forEach(obj => {
              if (obj.condition == 'TODAY') {
                obj.value = [date1, date2];
              } else if (obj.condition == 'THREE') {
                obj.value = [calDate('day', -2, date1), date2];
              } else if (obj.condition == 'WEEK') {
                obj.value = [calDate('day', -6, date1), date2];
              } else if (obj.condition == 'MONTH') {
                obj.value = [calDate('month', -1, date1), date2];
              } else if (obj.condition == 'NOW_MONTH') { //当月
                var now_Date = new Date();
                var currentMonth = now_Date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(now_Date.getFullYear(), nextMonth, 1);
                obj.value = [new Date(now_Date.getFullYear(), now_Date.getMonth(), 1), new Date(nextMonthFirstDay.getTime() - 1)];
              } else if (obj.condition == 'LAST_MONTH') { //上月
                var now_Date = new Date();
                var currentMonthFirstDay = new Date(now_Date.getFullYear(), now_Date.getMonth(), 1);
                var lastMonthlastDay = new Date(currentMonthFirstDay.getTime() - 1);
                obj.value = [new Date(lastMonthlastDay.getFullYear(), lastMonthlastDay.getMonth(), 1), lastMonthlastDay];
              } else if (obj.condition == 'NOW_YEAR') { //当年
                obj.value = [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31, 23, 59, 59)];
              } else if (obj.condition == 'LAST_YEAR') { //去年
                obj.value = [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59)];
              }
            });
          } else {
            this.gcomCondsList[index].aan004 = JSON.parse(this.gcomCondsList[index].aan004);
          }
          this.gcomCondsList[index].aan004.moresel.forEach(obj => {
            var searchlableList_v = this.searchlableList.filter(x => { return x.value == obj.field_no && x.table_no == obj.table_no && x.lable_type == obj.lable_type });
            if (searchlableList_v && searchlableList_v.length > 0) {
              obj.more01 = searchlableList_v[0].more01;
            }
          })
         }
        }

      }
      this.gcomCondsList.push({ label: this.translateService.instant('com-保存常用查询') , value: 'save' });
      this.gcomCondsList.push({ label: this.translateService.instant('com-编辑常用查询') , value: 'edit' });
      const searchSession = sessionStorage.getItem(this.programId + '_searchMore') || sessionStorage.getItem(this.programId);
      if (!searchSession) {
        var filterData = JSON.parse(JSON.stringify(this.gcomCondsList.filter(obj => obj.aan005 == 'Y')));
        if (filterData.length > 0) {
          this.searchParam.gcomConds = filterData[0].value;
          if (filterData[0].aan004.moresel) {
            this.searchVal = [];
            this.searchVal = this.searchVal.concat(filterData[0].aan004.moresel);
          }
          this.searchParam.glikesel = filterData[0].aan004.likesel || '';
          if (filterData[0].aan004.orderfields && filterData[0].aan004.orderfields.length > 0) {
            this.orderByList = filterData[0].aan004.orderfields;
          }
          // var aan004str = JSON.parse(filterData[0].aan004);
          // if (aan004str.moresel) {
          //   this.searchVal = aan004str.moresel;
          // }
          // this.searchParam.glikesel = aan004str.likesel || '';
          this.isAutoSearch = true;// 有默认查询条件的默认查询
          console.log('默认查询=== ')
          // 判断如果有默认查询条件且至少有一个栏位有值，则默认展开，否则关闭
          const valueList = this.searchVal.filter(x => x.value);
          if (valueList.length >= 1) {
            if (isCollapse === undefined) {
              this.clickCollapse(false);
            } else {
              this.clickCollapse(isCollapse);
            }
          } else {
            if (isCollapse === undefined) {
              this.clickCollapse(true);
            } else {
              this.clickCollapse(isCollapse);
            }
          }
        } else {
          //都无条件时将默认查询条件展示在更多查询中
          var defLabelList = this.searchlableList.filter(obj => { return obj.aal007 == 'Y' });
          if (defLabelList.length > 0) {
            for (let index = 0; index < defLabelList.length; index++) {
              var valObj = { table_no: '', field_no: '', condition: 'EQUAL', value: '', lable_type: '3', more01: [], cond_type: 'all', aae005: 'VARCHAR2' };
              var newobj = Object.assign(valObj, {
                field_no: defLabelList[index].value,
                aae005: defLabelList[index].aae005,
                aal005: defLabelList[index].aal005,
                openKey: defLabelList[index].openKey,
                param_list: defLabelList[index].param_list,
                lable_type: defLabelList[index].lable_type,
                more01: defLabelList[index].more01,
                table_no: defLabelList[index].table_no,
              });
              if (newobj.lable_type == '1' || newobj.lable_type == '3') {
                newobj.cond_type = 'all';
              } else if (newobj.lable_type == '2' || newobj.lable_type == '6') {
                newobj.cond_type = 'select';
              } else if (newobj.lable_type == '4' || newobj.lable_type == '5') {
                newobj.cond_type = 'date';
              } else if (newobj.lable_type == '7') {
                newobj.cond_type = 'month';
              } else {
                newobj.cond_type = 'all';
              }
              this.searchVal[index] = newobj;
            }
            // this.clickCollapse(isCollapse);
            this.clickCollapse(true);
          }
        }
        if (isReay) { // 控件初始化
          this.onReady.emit(true);
        }
        if (this.isAutoSearch) {
          this.searchData(true);
        }
      } else {
        this.clickCollapse(isCollapse);
        if (isReay) {// 控件初始化
          this.onReady.emit(true);
        }
        if (this.isAutoSearch) {
          this.searchData(false);
        }
      }
    });
  }
  // 日期格式化的方法
  dateFtt(fmt: string, date: Date): any {
    var o = {
      "M+": date.getMonth() + 1,                  //月份
      "d+": date.getDate(),                       //日
      "h+": date.getHours(),                      //小时
      "m+": date.getMinutes(),                    //分
      "s+": date.getSeconds(),                    //秒
      "q+": Math.floor((date.getMonth() + 3) / 3),//季度
      "S": date.getMilliseconds()                 //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  getStorageCondition(): void {
    var searchSession = sessionStorage.getItem(this.programId + '_searchMore') || sessionStorage.getItem(this.programId);
    if (searchSession !== null && searchSession !== undefined && searchSession !== 'null' && searchSession !== '') {
      this.searchVal = JSON.parse(searchSession).searchVal;
      this.searchParam.gcomConds = JSON.parse(searchSession).gcomConds;
      this.searchParam.glikesel = JSON.parse(searchSession).glikesel;
      // if (JSON.parse(searchSession).orderfields.length > 0) {
      //   this.orderByList = JSON.parse(searchSession).orderfields.map(obj => {
      //     // return {table_no: obj.acj005, name: obj.acj002, orderby: obj.acj003}
      //     return {acj005: obj.table_no, acj002: obj.name, acj003: obj.orderby}
      //   });
      // }
      if (JSON.parse(searchSession).orderfields && JSON.parse(searchSession).orderfields.length > 0) {
        this.orderByList = JSON.parse(searchSession).orderfields;
      }
      // this.searchParam.orderfields = JSON.parse(searchSession).orderfields;
    } else {
      this.searchParam.gcomConds = '';
      this.searchParam.glikesel = '';
      this.searchParam.orderfields = [];
    }
  }

  /**
   * getCondlabel
   * 获取更多查询条件
   */
  public getCondlabel(xarry: any, xdata: any) {
    xarry.forEach(element => {
      var filterData = xdata.filter(obj => obj.value == element.value);
      element.label = filterData.length > 0 ? filterData[0].label : element.label;
    });
    return xarry;
  }
  public getAal009List(xdata: any) {
    // var xdataList = xdata.split(',');
    var xdataList = xdata;
    var aal009List = [];
    this.searchCondList.self.forEach(element => {
      var filterData = xdataList.filter(obj => obj == element.value);
      if (filterData.length > 0) {
        aal009List.push(element);
      }
    });
    return aal009List;
  }

  //更多查询条件label change
  //1、开窗 2、单选 3、text 4、日期 5、日期时间 6、多选 7、年月  // 8、日期区间 9日期时间区间
  public changesearchfield(index: any): void {
    this.searchVal[index].value = '';
    this.searchVal[index].condition = 'EQUAL';
    if (this.searchVal[index].field_no) {
      var fieldArray = this.searchlableList.filter(obj => obj.value == this.searchVal[index].field_no);
      if (fieldArray.length > 0) {
        this.searchVal[index].lable_type = fieldArray[0].lable_type;
        this.searchVal[index].table_no = fieldArray[0].table_no;
        this.searchVal[index].more01 = fieldArray[0].more01;
        this.searchVal[index].aae005 = fieldArray[0].aae005;
        this.searchVal[index].aal005 = fieldArray[0].aal005;
        this.searchVal[index].openKey = fieldArray[0].openKey;
        this.searchVal[index].param_list = fieldArray[0].param_list;
        this.searchVal[index].aal004 = fieldArray[0].aal004;
        this.searchVal[index].param_list_bak = fieldArray[0].param_list_bak ? JSON.parse(JSON.stringify(fieldArray[0].param_list_bak)) : '';
      }
      if (fieldArray[0].aal009 && fieldArray[0].aal009.length > 0) {
        this.searchVal[index].cond_type = 'self';
        this.searchVal[index].aal009List = this.getAal009List([fieldArray[0].aal009]);
      } else {
        if (this.searchVal[index].lable_type == '1' || this.searchVal[index].lable_type == '3') {
          this.searchVal[index].cond_type = 'all';
        } else if (this.searchVal[index].lable_type == '2' || this.searchVal[index].lable_type == '6') {
          this.searchVal[index].cond_type = 'select';
          this.searchVal[index].value = [];
          if (this.searchVal[index].aal005 === null) {
            this.searchVal[index].more01 = [];
          }
        } else if (this.searchVal[index].lable_type == '4' || this.searchVal[index].lable_type == '5') {
          this.searchVal[index].cond_type = 'date';
          this.searchVal[index].between = false;
        } else if (this.searchVal[index].lable_type == '7') {
          this.searchVal[index].cond_type = 'month';
          this.searchVal[index].between = false;
        } else {
          this.searchVal[index].cond_type = 'all';
        }
      }

    } else {
      this.searchVal[index].lable_type = '3';
      this.searchVal[index].table_no = '';
      this.searchVal[index].more01 = [];
      this.searchVal[index].cond_type = 'all';
    }
  }

  /**
   * name
   */
  public changesearchCondition(index) {
    if (this.searchVal[index].lable_type == '4' || this.searchVal[index].lable_type == '5' || this.searchVal[index].lable_type == '7' || this.searchVal[index].lable_type == '8') {
      if (this.searchVal[index].condition == 'BETWEEN' || this.searchVal[index].condition == 'TODAY'
        || this.searchVal[index].condition == 'THREE' || this.searchVal[index].condition == 'WEEK'
        || this.searchVal[index].condition == 'MONTH' || this.searchVal[index].condition == 'NOW_MONTH'
        || this.searchVal[index].condition == 'LAST_MONTH' || this.searchVal[index].condition == 'NOW_YEAR'
        || this.searchVal[index].condition == 'LAST_YEAR') {
        this.searchVal[index].between = true;
        var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
        var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
        var now_Date = new Date();
        switch (this.searchVal[index].condition) {
          case 'BETWEEN':
            this.searchVal[index].value = [];
            break;
          case 'TODAY':
            this.searchVal[index].value = [date1, date2];
            break;
          case 'THREE':
            this.searchVal[index].value = [calDate('day', -2, date1), date2];
            break;
          case 'WEEK':
            this.searchVal[index].value = [calDate('day', -6, date1), date2];
            break;
          case 'MONTH':
            this.searchVal[index].value = [calDate('month', -1, date1), date2];
            break;
          case 'NOW_MONTH':
            var currentMonth = now_Date.getMonth();
            var nextMonth = ++currentMonth;
            var nextMonthFirstDay = new Date(now_Date.getFullYear(), nextMonth, 1);
            this.searchVal[index].value = [new Date(now_Date.getFullYear(), now_Date.getMonth(), 1), new Date(nextMonthFirstDay.getTime() - 1)];
            break;
          case 'LAST_MONTH':
            var currentMonthFirstDay = new Date(now_Date.getFullYear(), now_Date.getMonth(), 1);
            var lastMonthlastDay = new Date(currentMonthFirstDay.getTime() - 1);
            this.searchVal[index].value = [new Date(lastMonthlastDay.getFullYear(), lastMonthlastDay.getMonth(), 1), lastMonthlastDay];
            break;
          case 'NOW_YEAR':
            this.searchVal[index].value = [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31, 23, 59, 59)];
            break;
          case 'LAST_YEAR':
            this.searchVal[index].value = [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59)];
            break;
          default:
            this.searchVal[index].value = [];
            break;
        }
      } else {
        this.searchVal[index].between = false;
        this.searchVal[index].value = null;
      }
    }

  }

  /**
   * clickCollapse
   * 打开关闭更多查询
   */
  public clickCollapse(isCollapse?: boolean) {
    if (isCollapse !== undefined) {
      // this.isCollapse = JSON.parse(JSON.stringify(isCollapse));
      this.isCollapse = isCollapse;
    } else {
      this.isCollapse = !this.isCollapse;
    }
    if (this.isAutoHeight && this.heightEle) {
      if (this.isCollapse) { //关闭更多查询
        this.heightEle.style.height = this.initHeight;
      } else {
        var count = this.searchVal.length > 24 ? 33*8 +5+33 : (33 * Math.ceil(this.searchVal.length / 3)) + 6.5;
        this.heightEle.style.height = this.initHeight.replace(')', (' - ' + count  + 'px)'));
      }
    }
    if (!this.isCollapseInit) {
      this.isCollapseInit = true;
    }
  }
  /**
   * 添加更多查询条件
   */
  public addMore(): void {
    var nowLen = this.searchVal.length;
    for (let index = nowLen; index < (nowLen + 3); index++) {
      const newobj = Object.assign({}, this.searchValObj);
      this.searchVal[index] = newobj;
    }
    if (this.heightEle && this.searchVal.length <= 24 && this.isAutoHeight) {
      this.heightEle.style.height = this.heightEle.style.height.replace(')', ' - 33px)');
    }
    console.log('添加更多', this.searchVal);
  }

  // 获取form表单的高度
  getFormHeight(): void {
    var newLen = this.searchVal.length - 3;
    if (newLen <= 1&&this.heightEle) {
      this.heightEle.style.height = this.heightEle.style.height.replace(')', ' - 60px)');
      this.initHeight = this.heightEle.style.height;
    }
  }

  /**
   * 添加更多查询条件
   */
  public minusMore(index): void {
    var newLen = this.searchVal.length - 3;

    if (newLen > 1) {
      this.searchVal.splice(index-2, 3);
      if (this.heightEle && this.searchVal.length <= 21  && this.isAutoHeight) {
        this.heightEle.style.height = this.heightEle.style.height.replace(')', ' + 33px)');
      }
    }
    console.log('添加更多', this.searchVal);
  }

  /**
   * 查询事件
   *
   * @param {boolean} [isAsync=false] 是否同步处理
   * @memberof DocumentOrderComponent
   */
  public searchData(isAsync: boolean = true): void {
    // sessionStorage.setItem(this.programId, JSON.stringify({searchVal: this.searchVal, pageNumber: 1, pageSize: 10}));
    if (this.getsearchParam()) {
      this.onSearch.emit(isAsync);
      this.changeOrderCondition();
    };

  }

  getsearchParam() {
    // 传入参数错误，存在SQL注入风险！
    var ischeck = true;
    this.searchParam.condition.items = [];
    var sqlstr = ''
    var reg = new RegExp('\(\\b\(and|exec|insert|select|drop|grant|alter|delete|update|count|chr|mid|master|truncate|char|declare|or\)\\b\)|\(\\*|;|\\+|\'|%\)');

    //var reg = new RegExp('\(\\b\(and|exec|insert|select|drop|grant|alter|delete|update|count|chr|mid|master|truncate|char|declare|or\)\\b\)');
    this.searchParam.glikesel = _.trim(this.searchParam.glikesel);
    // if (reg.test(this.searchParam.glikesel)) {
    //   sqlstr = '关键字';
    // }else {
      if (this.orderByList.length > 0) {
        this.searchParam.orderfields = this.orderByList.map(obj => {
          return {table_no: obj.acj005, name: obj.acj002, orderby: obj.acj003}
        });
      } else  {
        this.searchParam.orderfields = [];
      }

    for (const obj of this.searchVal) {
      // if (reg.test(obj.value) && (this.c_S004 !== '0')) {
      //   if (sqlstr) {
      //     sqlstr = this.searchlableList.filter( item => {return item.value == obj.field_no})[0].label;
      //   } else {
      //     sqlstr = sqlstr + ',' + this.searchlableList.filter( item => {return item.value == obj.field_no})[0].label;
      //   }
      // } else {
      var valData = [];
      if (obj.field_no != '') {
        if (obj.condition == 'IS_BLANK' || obj.condition == 'NOT_BLANK') {
          this.searchParam.condition.items.push({
            table_no: obj.table_no,
            name: obj.field_no,
            operator: obj.condition,
            value: valData,
            type: obj.lable_type
          });
        } else {
          if (isString(obj.value) && obj.value != '') {
            obj.value = _.trim(obj.value);
            valData = obj.value.split(new RegExp('[,|\x22|\n|,\n|，]+'));
            obj.condition2 = obj.condition;
          } else if (isDate(obj.value) && obj.value != null) {
            if (obj.lable_type == '4') {
              var valdate = (new DatePipe('zh_tw')).transform(obj.value, 'yyyy/MM/dd');
            } else if (obj.lable_type == '7') {
              var valdate = (new DatePipe('zh_tw')).transform(obj.value, 'yyyy/MM');
            } else {
              var valdate = (new DatePipe('zh_tw')).transform(obj.value, 'yyyy/MM/dd HH:mm:ss');
            }
            valData = [valdate];
            obj.condition2 = obj.condition;
          } else if (isArray(obj.value) && obj.value.length > 0) {
            for (let index = 0; index < obj.value.length; index++) {
              if (obj.lable_type == '4') {
                obj.condition2 = 'BETWEEN'
                valData[index] = (new DatePipe('zh_tw')).transform(obj.value[index], 'yyyy/MM/dd');
              } else if (obj.lable_type == '5') {
                obj.condition2 = 'BETWEEN'
                valData[index] = (new DatePipe('zh_tw')).transform(obj.value[index], 'yyyy/MM/dd HH:mm:ss');
              }  else if (obj.lable_type == '7') {
                obj.condition2 = 'BETWEEN'
                valData[index] = (new DatePipe('zh_tw')).transform(obj.value[index], 'yyyy/MM');
              } else {
                valData[index] = obj.value[index];
                obj.condition2 = obj.condition;
              }
            }
          }
          if (valData.length > 0) {
            this.searchParam.condition.items.push({
              table_no: obj.table_no,
              name: obj.field_no,
              operator: obj.condition2,
              value: valData,
              type: obj.lable_type
            });
          }

          // 数值区间额外处理
          if (obj.lable_type == '8' && obj.condition == 'BETWEEN' && obj.valueStart && obj.valueEnd) {
            obj.condition2 = obj.condition;
            this.searchParam.condition.items.push({
              table_no: obj.table_no,
              name: obj.field_no,
              operator: obj.condition2,
              value: valData,
              type: obj.lable_type
            });
          }
        }
      }

      // }
    }
    // //暂时注销掉
    // if (sqlstr && (this.c_S004 !== '0')) {
    //   this.dwMessage.errorNew(sqlstr +  this.translateService.instant('com-sqlZR'), this.translateService.instant('type_com-sqlZR'), '', '');
    //   ischeck = false;
    // }
    return ischeck;
  }

  /**
   * 常用查询条件
   */
  public changecomCond(xVal): void {
    console.log('常用查询', xVal);
    if (xVal != 'save' && xVal != 'edit') { //切换查询条件
      var fieldArray = this.gcomCondsList.filter(obj => obj.value == xVal);
      if (fieldArray.length > 0) {
        // var aan004str = JSON.parse(fieldArray[0].aan004);
        if (fieldArray[0].aan004.moresel) {
          this.searchVal = JSON.parse(JSON.stringify(fieldArray[0].aan004.moresel));
        }
        this.searchParam.glikesel = JSON.parse(JSON.stringify(fieldArray[0].aan004.likesel || ''));
        this.orderByList = JSON.parse(JSON.stringify(fieldArray[0].aan004.orderfields || ''));
      }
      this.searchData(true);
      this.clickCollapse(false);
    }
  }

  /**
   * 获取全部常用查询条件
   */
  public getALLCondition(conditionList): any[] {
    let allConditionList = [];
    // console.log('常用查询-重组前', conditionList);
    for (let index = 0; index < conditionList.length; index++) {
      conditionList[index].aan004 = conditionList[index].aan004.replace(/:USER/g, this.userService.userInfo['c_user'])
      conditionList[index].aan004 = conditionList[index].aan004.replace(/:TODAY/g, this.datePipe.transform(new Date(), this.dwDateFormat))
      conditionList[index].aan004 = conditionList[index].aan004.replace(/:ORG/g, this.userService.userInfo['c_org'])
      conditionList[index].aan004 = conditionList[index].aan004.replace(/:PER/g, this.userService.userInfo['c_per'])
      if (conditionList[index].aan004.indexOf('TODAY') != -1 || conditionList[index].aan004.indexOf('THREE') != -1
        || conditionList[index].aan004.indexOf('WEEK') != -1 || conditionList[index].aan004.indexOf('MONTH') != -1
        || conditionList[index].aan004.indexOf('NOW_MONTH') != -1 || conditionList[index].aan004.indexOf('LAST_MONTH') != -1
        || conditionList[index].aan004.indexOf('NOW_YEAR') != -1 || conditionList[index].aan004.indexOf('LAST_YEAR') != -1) {
        conditionList[index].aan004 = JSON.parse(conditionList[index].aan004);
        var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
        var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
        conditionList[index].aan004.moresel.forEach(obj => {
          if (obj.condition == 'TODAY') {
            obj.value = [date1, date2];
          } else if (obj.condition == 'THREE') {
            obj.value = [calDate('day', -2, date1), date2];
          } else if (obj.condition == 'WEEK') {
            obj.value = [calDate('day', -6, date1), date2];
          } else if (obj.condition == 'MONTH') {
            obj.value = [calDate('month', -1, date1), date2];
          } else if (obj.condition == 'NOW_MONTH') { //当月
            var now_Date = new Date();
            var currentMonth = now_Date.getMonth();
            var nextMonth = ++currentMonth;
            var nextMonthFirstDay = new Date(now_Date.getFullYear(), nextMonth, 1);
            obj.value = [new Date(now_Date.getFullYear(), now_Date.getMonth(), 1), new Date(nextMonthFirstDay.getTime() - 1)];
          } else if (obj.condition == 'LAST_MONTH') { //上月
            var now_Date = new Date();
            var currentMonthFirstDay = new Date(now_Date.getFullYear(), now_Date.getMonth(), 1);
            var lastMonthlastDay = new Date(currentMonthFirstDay.getTime() - 1);
            obj.value = [new Date(lastMonthlastDay.getFullYear(), lastMonthlastDay.getMonth(), 1), lastMonthlastDay];
          } else if (obj.condition == 'NOW_YEAR') { //当年
            obj.value = [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31, 23, 59, 59)];
          } else if (obj.condition == 'LAST_YEAR') { //去年
            obj.value = [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59)];
          }
        });
      } else {
        conditionList[index].aan004 = JSON.parse(conditionList[index].aan004);
      }
      conditionList[index].aan004.moresel.forEach(obj => {
        var searchlableList_v = this.searchlableList.filter(x => { return x.value == obj.field_no && x.table_no == obj.table_no && x.lable_type == obj.lable_type });
        if (searchlableList_v && searchlableList_v.length > 0) {
          obj.more01 = searchlableList_v[0].more01;
        }
      })
    }
    // console.log('常用查询-重组后', conditionList);
    conditionList.forEach(x=>{
      if (x.aan004.moresel) {
        this.searchVal = JSON.parse(JSON.stringify(x.aan004.moresel));
      }
      this.searchParam.glikesel = JSON.parse(JSON.stringify(x.aan004.likesel || ''));
      // this.orderByList = JSON.parse(JSON.stringify(x.aan004.orderfields || ''));
      this.getsearchParam();
      // console.log(this.searchParam.condition);
      // console.log(this.searchParam.glikesel);
      let newCondition = JSON.parse(JSON.stringify({
        "condition": this.searchParam.condition,
        "glikesel": this.searchParam.glikesel,
        "gcomConds": x.value
      }));
      allConditionList.push(newCondition);
    });
    this.getStorageCondition();
    // console.log(allConditionList);
    return allConditionList;
  }

  //下拉菜单打开状态变化回调
  public openChangecomCond(xVal): void {
      if (xVal == 'save') {
        const modal = this.dwModalService.create({
          dwTitle: '保存常用查询条件',
          dwContent: saveCondComponent,
          dwStyle: { top:'100px',left: 0,right: 0},
          dwComponentParams: {
            programId: this.programId
          }, //入参使用@input
          dwClassName: 'fx_fillter_model',
          dwWidth: window.screen.width * 0.5,
          dwWrapClassName: 'fx_sm_modal',
          dwOnOk: (result: any): void => {
            this.saveComCond(result, 'save');
            modal.destroy();
          },
          dwOnCancel(): void {
            modal.destroy();
          },
          dwFooter: null
        });
      } else if (xVal== 'edit') {
        var dataList = [];
        for (let index = 0; index < this.gcomCondsList.length; index++) {
          this.gcomCondsList[index].aan005c = this.gcomCondsList[index].aan005 == 'Y' ? true : false;
          if (this.gcomCondsList[index].value != 'save' && this.gcomCondsList[index].value != 'edit' && this.gcomCondsList[index].aan001 != 'ALL') {
            dataList.push(this.gcomCondsList[index]);
          }
        }
        const modal = this.dwModalService.create({
          dwTitle: '编辑常用查询条件',
          dwContent: editCondComponent,
          dwComponentParams: {
            programId: this.programId,
            dataList: dataList
          },
          dwStyle: { top:'100px',left: 0,right: 0},
          dwWidth: window.screen.width * 0.5,
          dwWrapClassName: 'fx_sm_modal',
          dwOnOk: (result: any): void => {
            this.saveComCond(result.dataList, 'edit');
            modal.destroy()
          },
          dwOnCancel(): void {
            modal.destroy()
          },
          dwFooter: null
        });
      }
  }

  /**
   * 保存常用条件
   */
  public saveComCond(xResult: any, xState) {
    if (xState == 'save') {
      // 保存常用查询条件判断如果是：当天，三天内，一周内，一月内，当月，上月，当年，去年,改成动态日期
      this.searchVal.forEach(x => {
        if (x.condition === 'TOADY' || x.condition === 'THREE' || x.condition === 'WEEK' || x.condition === 'MONTH'
        || x.condition === 'NOW_MONTH' || x.condition === 'LAST_MONTH' || x.condition === 'NOW_YEAR' || x.condition === 'LAST_YEAR') {
          x.value = ':' + x.condition;
        }
      });
      var searchVal_v = [...this.searchVal];
      // more01不做存储
      for (var i = 0;i < searchVal_v.length;i++) {
        searchVal_v[i].more01 = [];
      }
      var aan004str = JSON.stringify({
        moresel: searchVal_v || [],
        likesel: this.searchParam.glikesel,
        orderfields: this.orderByList
      });
      var comCondParam = {
        aan001: this.userService.userInfo['c_user'], //用户编号
        aan002: this._programId, //作业编号
        value: '',
        label: xResult.addForm.get('label').value,
        aan004: aan004str,
        aan005: xResult.addForm.get('aan005').value ? 'Y' : 'N',
        adk_f_list: xResult.btnList.filter(s => s.selected) // 查询条件按钮
      };
      this.http.post<any>('A/IACommonService/pub_add_aan', { param: comCondParam }).subscribe(result => {
        // console.log('保存常用查询', result);
        var msg = result.message;
        if (result.success) {
          this.dwMessage.success('常用查询保存成功！');
          this.getComCondData(this.isCollapse);
        } else {
          if (msg) {
            this.dwMessage.error(msg); // 單一訊息顯示
          }
        }
      });
    } else {
      xResult.forEach(element => {
        element.aan001 = this.userService.userInfo['c_user'];
        element.aan002 = this._programId;
        element.aan005 = element.aan005c ? 'Y' : 'N';
        element.aan004 = JSON.stringify(element.aan004);
        element.adk_f_list = element.btnList.filter(s => s.selected) // 查询条件按钮
      });
      this.http.post<any>('A/IACommonService/pub_upd_aan', { param: xResult }).subscribe(result => {
        // console.log('保存常用查询', result);
        var msg = result.message;
        if (result.success) {
          this.dwMessage.success('编辑常用条件成功！');
          this.getComCondData(this.isCollapse);
        } else {
          if (msg) {
            this.dwMessage.success(msg); // 單一訊息顯示
          }
        }
      });
    }

  }

  /**
   * setOrderBy
   * 设置排序方式
   */
  public setOrderBy(): void {
    this.isShowSort=!this.isShowSort;
    // const modal = this.dwModalService.create({
    //   dwTitle:this.translateService.instant('com-排序'),
    //   dwStyle: { top: '80px',left:window.screen.width * 0.35},
    //   dwWidth: window.screen.width * 0.3,
    //   dwMaskClosable: true, // 點擊遮罩是否允許關閉
    //   dwWrapClassName: 'fx_xs_modal',
    //   dwContent: SetOrderByComponent,
    //   dwComponentParams: {
    //     orderByParam: {
    //       orderByListInit: this.orderByListInit, //作业注册配置的排序条件
    //       orderByList: this.orderByList  //已经选择的排序条件
    //     }
    //   },
    //   dwFooter: [
    //     {
    //       label: "取消",
    //       shape: 'default',
    //       onClick: (data: any): void => {
    //         modal.destroy();
    //       }
    //     },
    //     {
    //       label: "确定",
    //       type: 'primary',
    //       onClick: (data: any): void => {
    //         if (data.MasterService.rowCachedFormGroup) {
    //           data.onMasterRowEditingStopped({});
    //           data.MasterService.rowCachedFormGroup = null;
    //           data.masterGridApi.stopEditing(false);
    //         }
    //         this.orderByList = data.myform.get('acj_f_list').getRawValue().filter(obj => {return obj.acj002});
    //         modal.close({});
    //         this.searchData(true);
    //       }
    //     }
    //   ],
    // });
  }

  /**
   * 清除
   *
   * @memberof DocumentOrderComponent
   */
  public resetForm(): void {
    // 查詢條件欄位初始化
    this.searchParam = {
      pageable: true,
      // pageSize: 10,
      // pageNumber: 1,
      glikesel: '',
      gcomConds: '',
      orderfields: [],
      condition: {
        joinOperator: 'AND',
        items: []
      }
    };
    this.searchVal.forEach(obj => {
      obj.table_no = this.searchValObj.table_no;
      obj.field_no = this.searchValObj.field_no;
      obj.condition = this.searchValObj.condition;
      obj.value = this.searchValObj.value;
      obj.lable_type = this.searchValObj.lable_type;
      obj.more01 = this.searchValObj.more01;
      obj.cond_type = this.searchValObj.cond_type;
      obj.aae005 = this.searchValObj.aae005;
      obj.openKey = this.searchValObj.openKey;
      obj.param_list = this.searchValObj.param_list;
      obj.aal005 = this.searchValObj.aal005;
      obj.aal004 = this.searchValObj.aal004;

    });
    console.log('cansh', this.searchVal);
    // for (let index = 0; index < this.searchValNum; index++) {
    //   this.searchVal[index] = newobj;
    // }
  }

  // 判断层级关系,返回当前存在关联的参数属性
  public getRelationShip(parent, current): string {
    let proExsit = ''; // 是否存在flag,默认不存在
    if (current.aal004 == '1' && current.param_list_bak) {
      for (var pro in current.param_list_bak) {
        if (current.param_list_bak[pro].indexOf(parent.field_no) !== -1) {// 判断当前开窗的入参是否与选择的字段有关联关系
          proExsit = pro;
        }
      }
    }
    return proExsit;
  }

  //开窗 ==  begin  ==
  public openParamModal($event: MouseEvent, isAsync: boolean = false, index): void {
    $event.preventDefault();
    if (this.searchVal[index].aal005) {// 判断作业注册里面如果有配置了开窗信息则调用开窗配置的信息
      if (!this.searchVal[index].openKey) {
        this.dwMessage.warning( this.translateService.instant('com-请至开窗中选中勾选显示字段的主键！') );
        return;
      }

      this.searchlableList.forEach(x => {
        if (x.aal004 == '1') {
          const pro = this.getRelationShip(x, this.searchVal[index]);
          console.log('pro', pro)
          if (pro && !this.searchVal[index].value) {
            this.searchVal[index].param_list[pro] = [];
          }
        }
      });
      const openModelParam = {
        modalID: this.searchVal[index].aal005,     // (必传) 开窗的编号
        postParam: [(this.searchVal[index].param_list) ? this.searchVal[index].param_list : {}],             // (必传) 查询参数，注意是数组
        mutilSelected: true,
        selected: [],
        isChkAuth: true,
        searchType: 'q'
      };
      this.fxModalService.searchFx(openModelParam, this.programId).subscribe(data => {
        this.searchVal[index].value = data.map(obj => {
          return obj[this.searchVal[index].openKey];
        });

        this.searchlableList.forEach(x => {
          if (x.aal004 == '1') {
            const pro = this.getRelationShip(x, this.searchVal[index]);
            if (pro) {
              x.param_list[pro] = this.searchVal[index].value;
            }
          }
        });
      });
    } else {// 调用作业的信息
      this.nowOpenIndex = index;
      this.openModal.emit(isAsync);
    }
  }

  public openTextModal($event: MouseEvent, isAsync: boolean = false, index): void {
    const modal = this.dwModalService.create({
      dwTitle:this.translateService.instant('comm-prompted'),
      dwStyle: { top: '40px' },
      dwWidth: window.screen.width * 0.4,
      dwMaskClosable: true, // 點擊遮罩是否允許關閉
      dwWrapClassName: 'fx_xs_modal',
      dwContent: textModalComponent,
      dwComponentParams: {
        textvalue: this.searchVal[index].value || ''
      },
      dwFooter: [
        {
          label: "取消",
          shape: 'default',
          onClick: (data: any): void => {
            modal.destroy();
          }
        },
        {
          label: "确定",
          type: 'primary',
          onClick: (data: any): void => {
            this.searchVal[index].value = data.textvalue || '';
            modal.close({});
            this.searchData(true);
          }
        }
      ],
    });
  }

  public openSelect(isAsync: boolean = false, index): void {
    if (this.searchVal[index].aal005 === null || this.searchVal[index].aal005 === "") {
      this.nowOpenIndex = index;
      this.OptionList.emit(isAsync);
    }
  }


  onKeyDown(event): void {
    if (event.keyCode === 13) {
      this.searchData(true);
    }
  }

  //排序
  clickOrderBy(): void {

  }

  // 开窗 ==  end  ==

  //添加作业指标  == begin ==
  public cilckSchedule(event) {
    this.fxScheduleAry.forEach(element=>{
      if(event.aca006==element.aca006 && event.aca015==element.aca015){
        this.aca006=element.aca006;
        this.aca015=element.aca015;
        element.show=true;
      }else{
        element.show=false;
      }
    })
    // this.getProgramTarget();
    if(event.aca006 && event.aca015){
      var params = JSON.parse(event.aca015);
      for (let index = 0; index < this.searchValNum; index++) {
        const newobj = Object.assign({}, this.searchValObj);
        this.searchVal[index] = newobj;
      }
      Object.keys(params).forEach((name, index) => {
        if (params[name] === 'TODAY' || params[name] === 'THREE' || params[name] === 'WEEK' || params[name] === 'MONTH' ||
        params[name] === 'NOW_MONTH' || params[name] === 'LAST_MONTH' || params[name] === 'NOW_YEAR' || params[name] === 'LAST_YEAR') {
          var value = null, aae005 = 'date', lable_type = '4', cond_type = 'date', condition = 'EQUAL', condition2 = 'BETWEEN';// 记录查询条件的值
          var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
          var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
          if (params[name] == 'TODAY') {// 当天
            condition = 'TODAY';
            value = [date1, date2];
          } else if (params[name] == 'THREE') {// 三天内
            condition = 'THREE';
            value = [calDate('day', -2, date1), date2];
          } else if (params[name] == 'WEEK') {// 一周内
            condition = 'WEEK';
            value = [calDate('day', -6, date1), date2];
          } else if (params[name] == 'MONTH') {// 一月内
            condition = 'MONTH';
            value = [calDate('month', -1, date1), date2];
          } else if (params[name] == 'NOW_MONTH') { //当月
            condition = 'NOW_MONTH';
            var now_Date = new Date();
            var currentMonth = now_Date.getMonth();
            var nextMonth = ++currentMonth;
            var nextMonthFirstDay = new Date(now_Date.getFullYear(), nextMonth, 1);
            value = [new Date(now_Date.getFullYear(), now_Date.getMonth(), 1), new Date(nextMonthFirstDay.getTime() - 1)];
          } else if (params[name] == 'LAST_MONTH') { //上月
            condition = 'LAST_MONTH';
            var now_Date = new Date();
            var currentMonthFirstDay = new Date(now_Date.getFullYear(), now_Date.getMonth(), 1);
            var lastMonthlastDay = new Date(currentMonthFirstDay.getTime() - 1);
            value = [new Date(lastMonthlastDay.getFullYear(), lastMonthlastDay.getMonth(), 1), lastMonthlastDay];
          } else if (params[name] == 'NOW_YEAR') { //当年
            condition = 'NOW_YEAR';
            value = [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31, 23, 59, 59)];
          } else if (params[name] == 'LAST_YEAR') { //去年
            condition = 'LAST_YEAR';
            value = [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59)];
          }
          this.searchVal[index] = {
            between: true,
            aae005: aae005,
            aal005: null,
            aal008: "",
            cond_type: cond_type,
            condition: condition,
            condition2: condition2,
            field_no: name,
            lable_type: lable_type,
            more01: [],
            openKey: null,
            table_no: name.substring(0,3)+"_f",
            value: value,
          };
        } else {
          this.searchVal[index] = {
            aae005: "varchar2",
            aal005: null,
            aal008: "",
            cond_type: "all",
            condition: "EQUAL",
            condition2: "EQUAL",
            field_no: name,
            lable_type: "3",
            more01: [],
            openKey: null,
            table_no: name.substring(0,3)+"_f",
            value: params[name],
          };
        }
      });
      this.searchData(true);
            // 暂存当前页信息
            // event.aca006 = "fxhq001"
            // this.userService.getProgramParamById$(event.program_no).subscribe(programParam => {
            //   if (programParam && programParam.has('c_P006')) {
            //     sessionStorage.setItem(event.program_no + "_searchMore", JSON.stringify({
            //       searchVal: mySearchVal,
            //       gcomConds: "",
            //       glikesel: "",
            //       pageNumber: 1,
            //       pageSize: 10
            //     }));
            //     const navigationExtras: NavigationExtras = {
            //       relativeTo: this.route // 相對路徑導頁
            //     };
            //     var routeInfo: IDwRouteInfo = {
            //       id: event.program_no,
            //       menuId: getMenuName(event.program_no),
            //       name: '',
            //       routerLink: "/" + programParam.get('c_P006'),
            //       queryParams : {programId: event.program_no}
            //     };
            //     sessionStorage.setItem('homeIsAutoSearchParam' + event.program_no, 'Y'); // 标记一下如果是首页过去的默认都要自动查询
            //     this.dwRouteInfoService.create(routeInfo);
            //   } else {
            //     sessionStorage.setItem(event.aca006 + "_searchMore", JSON.stringify({
            //       searchVal: mySearchVal,
            //       gcomConds: "",
            //       glikesel: "",
            //       pageNumber: 1,
            //       pageSize: 10
            //     }));
            //     const navigationExtras: NavigationExtras = {
            //       relativeTo: this.route // 相對路徑導頁
            //     };
            //     var routeInfo: IDwRouteInfo = {
            //       id: event.aca006,
            //       menuId: getMenuName(event.aca006),
            //       name: '',
            //       routerLink: "/" + event.aca006,
            //       queryParams : {programId: event.aca006}
            //     };
            //     sessionStorage.setItem('homeIsAutoSearchParam' + event.aca006, 'Y'); // 标记一下如果是首页过去的默认都要自动查询
            //     this.dwRouteInfoService.create(routeInfo);
            //   }
            // });

    }
  }

  // public getProgramTarget() {
  //     //根据作业编号+用户获取当前作业是否有指定标签
  //     var targetEle = document.getElementById('fx_program_target_'+this._programId);
  //     var serachTargetEle = document.getElementById('fx_search_'+this._programId);
  //     var toolBarEle = document.querySelector('app-'+this._programId+ '-s01 .dw-f-btn');
  //     var gridHead = document.querySelector('app-'+this._programId+ '-s01 .fx_grid_head');

  //     var ishasTarget = false;
  //     this.http.post('A/IACommonService/getJobIndicators', { "param": {'aca001': '011'} }).subscribe(
  //       response => {
  //         if (response.success) {
  //           if (response.data && response.data.content.length > 0) {
  //             this.fxScheduleAry = response.data.content;
  //             const bColor=['#ff8f00','#ff8f00','#ff8f00'];
  //             const shadow=['0px 0px 6px #ff8f00','0px 0px 6px #ff8f00','0px 0px 6px #ff8f00'];
  //             const shadow_old=['0px 0px 6px #9a9696'];

  //             const result3 = this.fxScheduleAry.map((value, i) => { return Object.assign(value, {
  //               className: this.colorName[i%4],
  //               bColor:bColor[i%3],
  //               shadow:shadow[i%3],
  //               shadow_old:shadow_old ,
  //               show: (value.aca006==this.aca006 && value.aca015==this.aca015 )?true:false}) })
  //             this.fxScheduleAry = result3;
  //             ishasTarget = true; //根据服务返回当前作业是否有标签

  //             if (targetEle) {
  //               targetEle.setAttribute("style", "height: 60px;display:flex;");
  //             }
  //             if (serachTargetEle) {
  //               serachTargetEle.setAttribute("style", "position: relative;width: 40%;left: 60%;");
  //             }
  //             if (toolBarEle) {
  //               toolBarEle.setAttribute("style", "top: 60px;position: absolute;");
  //             }
  //             if (toolBarEle) {
  //               toolBarEle.setAttribute("style", "position: absolute;");
  //             }
  //             if (gridHead) {
  //               gridHead.setAttribute("style", "position: relative;");
  //             }
  //             this.getFormHeight();
  //           }
  //         }
  //       }
  //     )



  // }
  //添加作业指标  == end ==


  ngAfterViewInit(): void {
    // this.onReady.emit(true);
    // this.getProgramTarget();
    // this.getFormHeight();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.orderByListInit, event.previousIndex, event.currentIndex);
  }

  setASC(sort): void {
    if(sort.acj003=="ASC"){
      sort.acj003='X'
    }else{
      sort.acj003='ASC'
    }
  }

  setDESC(sort): void {
    if(sort.acj003=="DESC"){
      sort.acj003='X'
    }else{
      sort.acj003='DESC'
    }
  }

  cancelSort(): void {
      this.isShowSort=false
  }

  confirmSort(): void {
    this.isShowSort=false
    this.orderByList = this.orderByListInit.filter(obj =>{ return obj.acj003 == 'DESC'||obj.acj003 == 'ASC'});
    this.searchData(true);
  }

   clickSearchEdit(): void {

    this.openChangecomCond("edit");
  }

    // 点击常用查询条件
  clickSearchCondition(conIdx,item): void {

      if(item.type){
        this.searchParam.gcomConds = this.conditionList[conIdx].aan003_n1;
        this.cilckSchedule(item);
        this.clickCollapse(false);
      }else{
        this.searchParam.gcomConds = this.conditionList[conIdx].value;
        this.changecomCond(this.conditionList[conIdx].value)
      }
      // 点击常用查询条件过滤对应按钮数据
      let btnList = JSON.parse(JSON.stringify(this.btnListAll));
      if (item.adk_f_list && item.adk_f_list.length) {
        item.adk_f_list.forEach(s => {
          s.id = s.adk004;
        })
        btnList = item.adk_f_list;
      }
      this.btnData =btnList;
      this.onRefreshBtns.emit({btnList: btnList});
    }

    // 根据查询的条件更新排序弹窗的状态
    changeOrderCondition(): void {
      // 不存在排序条件清空排序
      if (!this.orderByList || this.orderByList.length == 0) {
        this.orderByListInit.forEach(obj => {
          obj.acj003 = 'X';
        });
      }
      this.orderByList.forEach(con => {
        if (con.acj003 == 'DESC' || con.acj003 == 'ASC') {
          this.orderByListInit.forEach(obj => {
            if (obj.acj005 == con.acj005 && obj.acj002 == con.acj002) {
              obj.acj003 = con.acj003;
            }
          });
        }
      });
    }
}
